import React from "react";
import './../styles/LongProjectInfo.css';
const LongProjectInfo = function (props) {
    return React.createElement("div", { className: "longProjectInfoWrapper" },
        React.createElement("div", { className: "longProjectInfo" },
            props.video === undefined ?
                undefined
                : React.createElement("video", { width: "100%", controls: true, muted: true, loop: true, playsInline: true, preload: "metadata" },
                    React.createElement("source", { src: props.video, type: "video/mp4" })),
            React.createElement("br", null),
            props.children),
        ")");
};
export default LongProjectInfo;
